
module.exports = function(a, b){
  var fn = function(){};
  fn.prototype = b.prototype;
  a.prototype = new fn;
  a.prototype.constructor = a;
};


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/~/component-inherit/index.js
// module id = ../../../../component-inherit/index.js
// module chunks = 4